import { render } from "./TodaySpecialSlider.vue?vue&type=template&id=6826d390"
import script from "./TodaySpecialSlider.vue?vue&type=script&lang=js"
export * from "./TodaySpecialSlider.vue?vue&type=script&lang=js"

import "./TodaySpecialSlider.vue?vue&type=style&index=0&id=6826d390&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__